<template>
  <div>
    <shouhu></shouhu>
  </div>
</template>

<script>
import shouhu from '@/views/shouhu.vue'
export default {
  components: {
    shouhu
  }
}
</script>

<style>

</style>
